import { CONSTANTS as COMMON_CONSTANTS } from '@common/constants/common.constants';

export const WEB_CONSTANTS = {};

export const CONSTANTS = Object.assign(COMMON_CONSTANTS, WEB_CONSTANTS);
